export default "__VITE_ASSET__C3g5$Jo___"